module.exports = __webpack_public_path__ + "img/icon@2x(4).99b15ee4.png";